module.exports = __webpack_public_path__ + "img/bg_classify4.c8fbdbc6.png";